import React, { useContext } from 'react';
import styles from './ReportSectionSelectListOption.module.scss';
import { SFIcon } from 'sfui';
import { Customer, CustomerContext } from 'ui-smartforce-settings';
import { formatDate } from '../../../../../../Helpers';

export interface ReportSectionSelectListOptionProps {
  incident_date: string;
  section_name: string;
  isSelected: boolean;
  onClick: () => void;
}

export const ReportSectionSelectListOption = ({
  incident_date,
  section_name,
  isSelected,
  onClick
}: ReportSectionSelectListOptionProps): React.ReactElement<ReportSectionSelectListOptionProps> => {
  const timezone = (useContext(CustomerContext).customer as Customer).timezone;

  const onKeyUp = (e: React.KeyboardEvent<HTMLLIElement>) => {
    if (e.key === 'Enter') {
      onClick();
    }
  };

  return (
    <li
      className={`${styles.reportSectionSelectListOption} ${
        isSelected ? styles.isSelected : ''
      }`}
      role="menuitem"
      onClick={onClick}
      onKeyUp={onKeyUp}
    >
      <span className={styles.listOptionIcon}>
        <SFIcon icon="Blank-File" size={22} />
      </span>

      <div className={styles.listOptionLabel}>
        <p className={styles.labelDate}>{section_name}</p>
        <p className={styles.labelAuthor}>
          {formatDate(incident_date, 'L - HH:mm', timezone)}
        </p>
      </div>
    </li>
  );
};
